export default {
  get name(): string {
    return 'ExpoScreenCapture';
  },
};
